/** @format */

import dynamic from "next/dynamic";
import { Layout } from "../components/common/Layout";
import Spinner from "../components/Spinner/Spinner";

const DynamicFAQ = dynamic(() => import("../components/FAQ/FAQ"), {
  ssr: false,
  loading: () => <Spinner />,
});

export default function FAQForWholesaleBuyers() {
  const meta = {
    title: "Qalara | Global sourcing & wholesale Verified suppliers & products",
    description:
      "Global wholesale platform for sourcing artisanal & sustainable lifestyle goods - Décor, Rugs ,Carpets, Kitchen, Fashion, Kids, Toys, Cushions, Home linen, vases",
    keywords:
      "handmade, fair trade, wholesale buying, global sourcing, Indian crafts, Exporters from India, Verified manufacturers and suppliers, B2B platform",
    url: "/FAQforwholesalebuyers/",
  };

  return (
    <Layout meta={meta}>
      <>
        <DynamicFAQ />
      </>
    </Layout>
  );
}
